// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1811":"2b40c7e3","5133":"2b40c7e3","5216":"255e48c4"}[chunkId] + ".chunk.css";
};